import { AndroidMobileAppDrawer } from '@/features/authorization/components/AndroidMobileAppDrawer'
import { useBuzzAvailability } from '@/features/buzz/api'
import { HiveCallsPromo } from '@/features/buzz/components/HiveCallsPromo'

/**
 * The one place that decides which on-open overlay an authenticated page gets: the Hive
 * Calls promo when Buzz is on, otherwise the Android app drawer. They must never be open
 * together, so while `/configuration` is still pending this renders nothing — showing the
 * drawer first and swapping it for the promo once the flag resolves would stack or flash both.
 */
export const OnOpenPromo = () => {
  const availability = useBuzzAvailability()

  if (availability === 'pending') return null
  return availability === 'enabled' ? <HiveCallsPromo /> : <AndroidMobileAppDrawer />
}
